import React from "react";
import PropTypes from "prop-types";
import CommonDataTable from "../../../components/Datatable/CommonDataTable";
import Format from "../../../helpers/Format";
import { formataData } from "../../../helpers/mesesHelper";
import DropdownButton from "../../../components/dropdown/DropdownButton";
import CommonsHelper from "../../../helpers/CommonsHelper";
import CommonDropdown from "../../../components/dropdown/CommonDropdown";

function GerenciadorDataTable({
  linhas,
  downloadInvoice,
  togVisualizarModal,
  togEnviarEmailModal,
  deleteInvoice,
}) {
  const isMobile = CommonsHelper.isMobile();

  const colunas = React.useMemo(
    () => [
    {
        Header: "Tomador",
        accessor: "tomador",
      },
      {
        Header: "Número",
        accessor: (row) => {
          return `#${row.id}`;
        },
        isSorted: true,
        isSortedDesc: true,
      },
      {
        Header: "Valor",
        disableSortBy: true,
        accessor: (row) => {
          return Format.formataValor(row.valor || 0);
        },
      },
      {
        Header: "Data de referência",
        disableSortBy: true,
        accessor: (row) => {
          return formataData(row.data_emissao);
        },
      },
      {
        Header: "Ações",
        disableSortBy: true,
        Cell: ({ row }) => {
          const status = [];
          if (!isMobile) {
            status.push(
              <DropdownButton
                key={`visualizar-${row.original.uid}`}
                onClick={() => {
                  togVisualizarModal(row.original.caminho);
                }}
                color="primary"
                icon="mdi mdi-file-search"
              >
                Visualizar documento
              </DropdownButton>
            );
          }
          status.push(
            <DropdownButton
              key={`download-pdf-${row.original.uid}`}
              onClick={() => {
                downloadInvoice(
                  row.original.caminho,
                  row.original.id
                );
              }}
              color="success"
              icon="mdi mdi-cloud-download"
            >
              Download PDF
            </DropdownButton>
          );
          status.push(
            <DropdownButton
              key={`enviar-email-${row.original.uid}`}
              onClick={() => {
                togEnviarEmailModal(row.original.uid, row.original.amazon);
              }}
              color="info"
              icon="mdi mdi-email-send"
            >
              Enviar invoice por e-mail
            </DropdownButton>
          );

          status.push(
            <DropdownButton
              key={`excluir-arquivo-${row.original.uid}`}
              onClick={() => {
                deleteInvoice(row.original.uid);
              }}
              color="danger"
              icon="mdi mdi-delete"
            >
              Cancelar Invoice
            </DropdownButton>
          );

          return status.length > 0 && <CommonDropdown>{status}</CommonDropdown>;
        },
      },
    ],
    [
      isMobile,
      togVisualizarModal,
      downloadInvoice,
      togEnviarEmailModal,
      deleteInvoice,
    ]
  );
  return <CommonDataTable colunas={colunas} linhas={linhas} />;
}
GerenciadorDataTable.propTypes = {
  linhas: PropTypes.arrayOf(PropTypes.object).isRequired,
  downloadInvoice: PropTypes.func.isRequired,
  row: PropTypes.object,
  togVisualizarModal: PropTypes.func.isRequired,
  togEnviarEmailModal: PropTypes.func.isRequired,
  deleteInvoice: PropTypes.func.isRequired,
};

export default GerenciadorDataTable;
